import { render, staticRenderFns } from "./DPHV.vue?vue&type=template&id=03311917"
import script from "./DPHV.vue?vue&type=script&lang=js"
export * from "./DPHV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports